module.exports = __webpack_public_path__ + "img/coolBackground.d8c166b6.png";